<template>
  <div style="position: relative;" ref="formContainer">
    <div style="padding: 25px; display: flex;">
      <h5>Calendários de monitoramentos</h5>
      <span
        style="
          border-radius: 100%;
          background-color: #dcdcdc;
          height: 45px;
          width: 45px;
          padding-top: 4px;
          padding-left: 12px;
          font-size: 30px;
          margin-left: auto;
          cursor: pointer;
        "
        @click="goToTerritory"
      >
        X
      </span>
    </div>
    <Main>
      <SideBar>
        <div class="divClass">
          <div>
            <Title>Filtros</Title>
            <SubTitle>Monitoramento</SubTitle>
            <LineCustom />
            <ul>
              <li style="display: flex; flex-direction: column; align-items: stretch;">
                <CheckBoxRound
                  label="Geomonitoramento"
                  v-model="colors"
                  inputValue="orange"
                  :checked="hasChecked"
                />
                <CheckBoxRound
                  label="Autovistoria"
                  v-model="colors"
                  inputValue="blue"
                  :checked="hasChecked"
                />
              </li>
            </ul>
            <SubTitle>Meus territorórios</SubTitle>
            <LineCustom />
            <ul>
              <li v-for="i in territories" :key="i.id">
                <CheckBoxRound
                  :label="i.name"
                  :inputValue="i.id"
                  v-model="territoryCar"
                  :checked="hasChecked"
                />
              </li>
            </ul>
            <SubTitle>Meus Boletos</SubTitle>
            <LineCustom />
            <ul>
              <li v-for="i in getPaymentForCalendarData" :key="i.id">
                <CheckBoxRound
                  :label="i.customData.title"
                  :inputValue="i.id"
                  v-model="ticketObj"
                  :checked="hasChecked"
                />
              </li>
            </ul>
            <SubTitle>Act Vigente</SubTitle>
            <LineCustom />
            <ul>
              <li v-for="i in getActForCalendarData" :key="i.id">
                <CheckBoxRound
                  :label="i.customData.title"
                  :inputValue="i.key"
                  v-model="actData"
                  :checked="hasChecked"
                />
              </li>
            </ul>
            <span style="display: block; margin-top: 2rem;">
              <button class="clearFilter" @click="clearFilter">- Limpar Tudo</button>
            </span>
            <SubTitle>Período</SubTitle>
            <LineCustom />
            <div>
              <Select
                :options="getDatesEnable()"
                default="Selecione uma data"
                class="select"
                @input="handleSelect"
                messageEmpty="Nenhuma data encontrada"
              />
            </div>
            <SubTitle>Datas Act</SubTitle>
            <LineCustom />
            <div>
              <Select
                :options="getDatesAct()"
                default="Selecione uma data"
                class="select"
                @input="handleSelect"
                messageEmpty="Nenhuma data encontrada"
              />
            </div>
            <SubTitle>Datas Vencimentos Boletos</SubTitle>
            <LineCustom />
            <div>
              <Select
                :options="getDatesEnablePayment()"
                default="Selecione uma data"
                class="select"
                @input="handleSelect"
                messageEmpty="Nenhuma data encontrada"
              />
            </div>
          </div>
          <div>
            <Title>Legenda</Title>
            <LineCustom />
            <ul>
              <li class="legend">
                Geomonitoramento
              </li>
              <li class="legend">
                Autovistoria
              </li>
            </ul>
          </div>
        </div>
      </SideBar>
      <CalendarContainer>
        <v-calendar
          ref="calendar"
          class="custom-calendar"
          :masks="masks"
          :attributes="dates"
          disable-page-swipe
        >
          <template v-slot:day-content="{ day, attributes }">
            <div class="itemContainer">
              <span class="dayItem">{{ day.day }}</span>
              <div class="contentItem">
                <p
                  v-for="attr in attributes"
                  :key="attr.key"
                  class="text"
                  :class="attr.customData.class"
                  @click="toggleDate(attr, dates[0].cdTerritory, dates[0].status)"
                >
                  {{ attr.customData.title }}
                </p>
                <p
                  v-for="attr in attributes"
                  :key="attr.key"
                  class="text"
                  :class="'test'"
                >
                  <span v-if="attr.color === 'yellow'">{{ 'Data de vencimento do boleto' }}</span>
                </p>
              </div>
            </div>
          </template>
        </v-calendar>
      </CalendarContainer>
    </Main>
  </div>
</template>

<script>
import Vue from 'vue';
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import Select from '@/components/Select/index.vue';
import getTerritoryByAgentDocumentService from '@/services/territory/get-territory-by-agent-document';
import CheckBoxRound from '@/components/CheckBoxRound/index.vue';
import { formatStringOnlyNumbers } from '@/utils';
import {
  Main, SideBar, LineCustom, CalendarContainer, SubTitle, Title,
} from './styles';

export default Vue.extend({
  components: {
    Main,
    SideBar,
    LineCustom,
    CheckBoxRound,
    CalendarContainer,
    SubTitle,
    Title,
    Select,
  },
  data() {
    return {
      masks: {
        weekdays: 'WWW',
      },
      territories: [],
      check: false,
      dataCdTerritory: {
        cdTerritory: '',
      },
      dates: [],
      colors: ['blue', 'orange', 'red', 'black'],
      territoryCar: [],
      ticketObj: [],
      actData: [],
      actDataObj: [],
      cdTerritory: '',
      userLoged: JSON.parse(sessionStorage.getItem('userLogged')),
      hasChecked: true,
      tickets: [{
        duedate: '',
        status: '',
        ticketId: 0,
        ticketName: '',
      }],
      getPaymentForCalendarData: [{
        key: '',
        dates: '',
        customData: {
          title: '',
          class: 'yellow',
        },
        id: '',
        color: 'yellow',
        cdTerritory: 0,
      }],
      getActForCalendarData: [{
        key: '',
        dates: '',
        customData: {
          title: '',
          class: 'yellow',
        },
        id: '',
        color: 'yellow',
      }],
    };
  },
  computed: {
    ...mapGetters(['getAppointmentForCalendar', 'ticket', 'act']),
  },
  methods: {
    ...mapActions({
      getAppointmentDate: 'getAppointmentDate',
      getAppointmentRequest: 'getAppointmentRequest',
      getTickets: 'getTickets',
      getAct: 'getAct',
    }),
    goToTerritory() {
      this.$router.push({ name: 'Prod' });
    },
    goToGeo(dataType, dataInitial, dataEnd, car) {
      if (dataType !== 'orange') {
        this.$router.push({
          name: 'Autovistoria',
          params: { dataInitial, dataEnd, car },
        });
      } else {
        this.$router.push({
          name: 'Geomonitoramento',
          params: { dataInitial, dataEnd, car },
        });
      }
    },
    goToTickets(dataType, titleTicket, dataEnd, cdTerritory, status) {
      // this.$router.push(`${getUserGroup()}/territorio/${id}/${name}`);
      if (dataType === 'black') {
        this.$router.push({
          name: 'Ticket',
          params: {
            titleTicket, dataEnd, cdTerritory, status,
          },
        });
      }
    },
    async moveCalenderTickets() {
      const { calendar } = this.$refs;
      const date = moment(this.getPaymentForCalendarData[0].dates, 'L');
      await calendar.move({ month: date.month() + 1, year: date.year() });
    },
    async moveCalenderAct() {
      const { calendar } = this.$refs;
      const date = moment(this.getActForCalendarData[0].dates, 'L');
      await calendar.move({ month: date.month() + 1, year: date.year() });
    },
    toggleDate(dateInfo, cdTerritory, status) {
      const { dates, customData } = dateInfo;
      const { start } = dates[0];
      const getAppointment = this.getAppointmentForCalendar;
      const isDate = (appointment) => moment(appointment.dates).isSame(start)
        && customData.class === appointment.customData.class;
      const isEqualDate = getAppointment.find(isDate);
      const End = moment(dateInfo.dates[0].end).format('DD/MM/YYYY');
      this.goToTickets(dateInfo.customData.class, dateInfo.customData.title, End, cdTerritory, status);
      if (isEqualDate) {
        const SEVEN_DAYS = 7;
        const dateEnd = moment(start).add(SEVEN_DAYS, 'days').format('DD/MM/YYYY');
        const dateInitialFormat = moment(start).format('DD/MM/YYYY');
        this.goToGeo(isEqualDate.customData.class, dateInitialFormat, dateEnd, isEqualDate.car);
      }
    },
    removeChecked(value, arr) {
      const index = arr.indexOf(value);
      if (index > -1) {
        arr.splice(index, 1);
      }
    },
    filterParamsCheckeds() {
      return this.getAppointmentForCalendar
        .filter((ap) => this.territoryCar.includes(ap.id))
        .filter((ap) => this.colors.includes(ap.color));
    },
    filterParamsCheckedsPayment() {
      return this.getPaymentForCalendarData
        .filter((ap) => this.ticketObj.includes(ap.id))
        .filter((ap) => this.colors.includes(ap.color));
    },
    filterParamsCheckedsAct() {
      return this.getActForCalendarData
        .filter((ap) => this.actData.includes(ap.id))
        .filter((ap) => this.colors.includes(ap.color));
    },
    clearFilter() {
      this.territoryCar.length = 0;
      this.colors.length = 0;
      this.hasChecked = false;
      this.dates = this.filterParamsCheckeds();
    },
    async getTerritories() {
      const { stDocument } = this.userLoged;
      const formattedValue = formatStringOnlyNumbers(stDocument);
      this.territories = await getTerritoryByAgentDocumentService(formattedValue);
    },
    formatNote() {
      return this.territories.map((territory) => ({
        id: territory.id,
        agentId: territory.agents[0].id,
        tokenKey: this.userLoged.company.stKey,
      }));
    },
    async setAppointmentInNotification() {
      const territoriesFormat = this.formatNote();

      await this.getAppointmentRequest({ territoriesFormat });
    },
    async handleSelect(value) {
      const { calendar } = this.$refs;
      // this.hasChecked = !this.hasChecked;
      const date = moment(value, 'L');
      await calendar.move({ month: date.month() + 1, year: date.year() });
    },
    getDatesEnable() {
      return this.filterParamsCheckeds().map(
        (ap) => `${moment(ap.dates).format('L')} - ${ap.customData.title}`,
      );
    },
    getDatesEnablePayment() {
      return this.filterParamsCheckedsPayment().map(
        (ap) => `${moment(ap.dates).format('L')} - ${ap.customData.title}`,
      );
    },
    getDatesAct() {
      return this.filterParamsCheckedsAct().map(
        (ap) => `${moment(ap.dates).format('L')} - ${ap.customData.title}`,
      );
    },
    getPaymentForCalendar() {
      const sorted = this.tickets.sort((a, b) => moment(a.dueDate).valueOf() - moment(b.dueDate).valueOf());

      return sorted.map((appointment, index) => {
        const color = 'green';
        return {
          key: index,
          dates: new Date(appointment.dueDate),
          customData: {
            title: appointment.ticketName,
            class: color,
          },
          id: appointment.ticketId,
          color,
          cdTerritory: appointment.cdTerritory,
        };
      });
    },
    watchFilters() {
      this.$watch(
        (vm) => [vm.territoryCar, vm.colors, vm.getAppointmentForCalendar, vm.ticketObj],
        () => {
          this.dates = this.filterParamsCheckeds();
        },
      );
    },
  },
  watch: {
    territoryCar() {
      this.hasChecked = !this.hasChecked;
      if (this.hasChecked === false) {
        this.dates.length = 0;
        this.getPaymentForCalendarData.length = 0;
      }
      this.check = !this.check;
      this.cdTerritory = this.territoryCar;
      this.getTickets({ cdTerritory: this.territoryCar[0] }).then(() => {
        this.tickets = this.ticket.data.objectResult;
        this.ticket.data.objectResult.forEach((e) => {
          this.getPaymentForCalendarData.push({
            key: e.ticketId,
            dates: new Date(e.dueDate),
            customData: {
              title: e.ticketName,
              class: 'black',
            },
            id: e.ticketId,
            color: 'black',
            cdTerritory: e.cdTerritory,
            status: e.status,
          });
        });
      });
      const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
      this.getAct({ tokenKey: company.stKey, cdTerritory: this.cdTerritory[0] }).then(() => {
        this.actDataObj = this.act.data.objectResult[this.act.data.objectResult.length - 1];
        // this.getActForCalendarData[0].key = this.actDataObj.id;
        this.getActForCalendarData[0].dates = new Date(this.actDataObj.act);
        this.getActForCalendarData[0].customData.title = 'Act Vigente';
        this.getActForCalendarData[0].customData.class = 'red';
        this.getActForCalendarData[0].id = this.actDataObj.id;
        this.getActForCalendarData[0].color = 'red';
      });
    },
    ticketObj() {
      this.moveCalenderTickets();
      this.hasChecked = !this.hasChecked;
      if (this.hasChecked === false) {
        this.getPaymentForCalendarData.length = 0;
        this.dates = this.filterParamsCheckedsPayment();
      } else if (this.hasChecked === true) {
        this.getTickets({ cdTerritory: this.cdTerritory[0] }).then(() => {
          this.tickets = this.ticket.data.objectResult;
          this.ticket.data.objectResult.forEach((e) => {
            this.getPaymentForCalendarData.push({
              key: e.ticketId,
              dates: new Date(e.dueDate),
              customData: {
                title: e.ticketName,
                class: 'black',
              },
              id: e.ticketId,
              color: 'black',
              cdTerritory: e.cdTerritory,
              status: e.status,
            });
            this.dates = this.getPaymentForCalendarData;
          });
        });
      }
    },
    actData() {
      this.moveCalenderAct();
      const { company } = JSON.parse(sessionStorage.getItem('userLogged') || '{}');
      this.getAct({ tokenKey: company.stKey, cdTerritory: this.cdTerritory[0] }).then(() => {
        this.actDataObj = this.act.data.objectResult[this.act.data.objectResult.length - 1];
        this.getActForCalendarData[0].key = this.actDataObj.id;
        this.getActForCalendarData[0].dates = new Date(this.actDataObj.act);
        this.getActForCalendarData[0].customData.title = 'Act Vigente';
        this.getActForCalendarData[0].customData.class = 'red';
        this.getActForCalendarData[0].id = this.actDataObj.id;
        this.getActForCalendarData[0].color = 'red';
        this.dates = this.getActForCalendarData;
      });
    },
  },
  async mounted() {
    const loader = this.$loading.show({
      container: this.$refs.formContainer,
    });
    await this.getTerritories();
    if (this.getAppointmentForCalendar.length === 0) {
      await this.setAppointmentInNotification();
    }
    this.watchFilters();
    loader.hide();
  },
});
</script>
